import { Helmet } from "react-helmet-async";

const SITE_URL = "https://eaugratuite.io";
const DEFAULT_TITLE = "Eau Gratuite - Publicité sur bouteilles d'eau gratuites";
const DEFAULT_DESCRIPTION =
  "Plateforme publicitaire innovante et solidaire. Votre marque sur des bouteilles d'eau gratuites distribuées en Île-de-France, finançant des puits d'eau via l'Association Ulker's.";

export default function SEO({ title, description, path = "/" }) {
  const pageTitle = title ? `${title} | Eau Gratuite` : DEFAULT_TITLE;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const canonicalUrl = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />

      {/* Twitter */}
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
    </Helmet>
  );
}
